import { ga } from 'js/analytics/adapters'
export const trackStartRewatchVideo = () => {
  ga.track('Started rewatching video')
}
